export default __webpack_public_path__ + "static/media/Paropakari.13573dec.gif";